import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, app } from "../config/firebase";
import { AppSettings } from "../types/AppSettings";

export class SettingsApi {

  public static get = async (): Promise<AppSettings> => {
    const apiCall = httpsCallable<{ }, AppSettings>(
      getFunctions(app),
      "getSettings"
    );
    try {
      const res = await apiCall({ });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to get settings.");
    }
  }
  
  public static setPaymentState = async (bunchKey: string, isPaid: boolean): Promise<AppSettings> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    const apiCall = httpsCallable<{ bunchKey: string, isPaid: boolean }, AppSettings>(
      getFunctions(app),
      "setPaymentState"
    );
    try {
      const res = await apiCall({ bunchKey, isPaid });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to set payment state.");
    }
  }

  public static setRelayState = async (enabled: boolean): Promise<AppSettings> => {
    if (!auth.currentUser) throw new Error("Not signed in");
    const apiCall = httpsCallable<{ enabled: boolean }, AppSettings>(
      getFunctions(app),
      "setRelayState"
    );
    try {
      const res = await apiCall({ enabled });
      return res.data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to update relay state.");
    }
  }
}
